<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  referral: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const hasImage = computed(() => !!props.referral.imageUrl);
</script>

<template>
  <div
    class="flex flex-col gap-2 rounded-md border border-n-slate-6 bg-n-slate-3 p-2 text-xs"
  >
    <div class="flex items-center gap-1 text-n-slate-11">
      <span class="i-lucide-megaphone size-3" />
      <span class="font-medium uppercase tracking-wide">
        {{ t('AD_REFERRAL.LABEL') }}
      </span>
    </div>
    <div class="flex gap-2">
      <img
        v-if="hasImage"
        :src="referral.imageUrl"
        class="size-14 shrink-0 rounded object-cover"
        :alt="referral.headline"
      />
      <div class="flex min-w-0 flex-col gap-1">
        <span
          v-if="referral.headline"
          class="font-semibold text-n-slate-12 leading-tight"
        >
          {{ referral.headline }}
        </span>
        <span
          v-if="referral.body"
          class="line-clamp-2 text-n-slate-11 leading-snug"
        >
          {{ referral.body }}
        </span>
      </div>
    </div>
    <a
      v-if="referral.sourceUrl"
      :href="referral.sourceUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="skip-context-menu flex items-center gap-1 text-n-brand hover:underline"
    >
      <span class="i-lucide-arrow-up-right size-3" />
      {{ t('AD_REFERRAL.VIEW_AD') }}
    </a>
  </div>
</template>
